// This class contains the necessary method of gathering plan data for the policy replacement information form
// getFormMappings() would return an array of FoxIt fields with the corresponding value
import { FormMapping } from './FormMapping'

export default class ReplacementInformationForm extends FormMapping {
	constructor(planHolderId: string) {
		super(planHolderId)
	}

	getFormMappings() {
		return [
			...this.getProposedInsuredMapping(),
			...this.getProposedInsuredAddressMapping(),
			...this.getFuneralHomeMapping(),
		]
	}
}
